import { useEffect, useState } from 'react';

import CloseIcon from '../../../assets/icons/close.svg';
import api from '../../../services/api';
import handleError from '../../../utils/handleError';
import { maskPhone } from '../../../utils/mask';

import {
  Button,
  Close,
  CloseButton,
  Column,
  Container,
  Content,
  Detail,
  DetailLabel,
  DetailWrapper,
  Input,
  ModalHeader,
  Title,
} from './styles';

interface Form {
  name: string;
  phone: string;
  latitude: string;
  longitude: string;
  city: string;
}

export interface Result {
  id: string;
  name: string;
  phone: string;
  latitude: string;
  longitude: string;
  city: string;
  created_at: string;
}

interface Props {
  suportData?: Result;
  onClose: () => void;
}

export const ModalSuport: React.FC<Props> = ({ suportData, onClose }) => {
  const [state, setState] = useState<Form>({} as Form);

  const isUpdate = !!suportData?.id;

  useEffect(() => {
    if (suportData) {
      setState({
        name: suportData.name,
        phone: suportData.phone,
        latitude: suportData.latitude,
        longitude: suportData.longitude,
        city: suportData.city,
      });
    }
  }, [suportData]);

  const onSubmit = async () => {
    try {
      if (isUpdate) {
        await api.put(`/sos/contact/${suportData.id}`, {
          ...state,
        });

        handleError('Alteração realizada com sucesso!', 'success');
        onClose();
      } else {
        await api.post('/sos/contact', {
          ...state,
        });

        handleError('Cadastro realizado com sucesso!', 'success');
        onClose();
      }
    } catch (error: any) {
      handleError(error, 'error');
    }
  };

  return (
    <Container>
      <Content>
        <ModalHeader>
          <Title>Cadastro de Boia</Title>
          <CloseButton
            onClick={() => {
              onClose();
            }}
          >
            <Close src={CloseIcon} />
          </CloseButton>
        </ModalHeader>
        <Column>
          <DetailWrapper>
            <DetailLabel>Nome</DetailLabel>
            <Detail>
              <Input
                type="text"
                placeholder="Ex.: Suporte de Teste"
                value={state.name}
                onChange={e => {
                  const obj = {
                    ...state,
                    name: e.target.value,
                  };
                  setState(obj);
                }}
              />
            </Detail>
          </DetailWrapper>
          <DetailWrapper>
            <DetailLabel>Telefone</DetailLabel>
            <Detail>
              <Input
                type="text"
                placeholder="Ex.: (99) 99999-9999"
                value={state.phone}
                onChange={e => {
                  const obj = {
                    ...state,
                    phone: maskPhone(e.target.value),
                  };
                  setState(obj);
                }}
              />
            </Detail>
          </DetailWrapper>
          <DetailWrapper>
            <DetailLabel>Latitude</DetailLabel>
            <Detail>
              <Input
                type="text"
                placeholder="Ex.: 12.345678"
                value={state.latitude}
                onChange={e => {
                  const obj = {
                    ...state,
                    latitude: e.target.value,
                  };
                  setState(obj);
                }}
              />
            </Detail>
          </DetailWrapper>

          <DetailWrapper>
            <DetailLabel>Longitude</DetailLabel>
            <Detail>
              <Input
                type="text"
                placeholder="Ex.: 12.345678"
                value={state.longitude}
                onChange={e => {
                  const obj = {
                    ...state,
                    longitude: e.target.value,
                  };
                  setState(obj);
                }}
              />
            </Detail>
          </DetailWrapper>

          <DetailWrapper>
            <DetailLabel>Cidade</DetailLabel>
            <Detail>
              <Input
                type="text"
                placeholder="Ex.: São Paulo"
                value={state.city}
                onChange={e => {
                  const obj = {
                    ...state,
                    city: e.target.value,
                  };
                  setState(obj);
                }}
              />
            </Detail>
          </DetailWrapper>

          <Button type="button" onClick={onSubmit}>
            {isUpdate ? 'Atualizar' : 'Cadastrar'}
          </Button>
        </Column>
      </Content>
    </Container>
  );
};
